import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

export default function ValidandoPagamento() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const externalReference = searchParams.get("ref");
  const [segundos, setSegundos] = useState(5);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let interval;
    if (segundos > 0) {
      interval = setInterval(() => {
        setSegundos((s) => s - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [segundos]);

  useEffect(() => {
    const tentarBuscar = async (tentativas = 0) => {
      try {
        const res = await axios.get(`/api/comprovante-por-ref?ref=${externalReference}`);
        if (res.status === 200 && res.data && res.data.pagamento_id) {
          navigate(`/comprovante?payment_id=${res.data.pagamento_id}`);
        } else {
          throw new Error("Sem pagamento_id ainda");
        }
      } catch (err) {
        if (tentativas < 5) {
          setTimeout(() => tentarBuscar(tentativas + 1), 1500);
        } else {
          setErro(true);
        }
      }
    };

    if (externalReference) {
      tentarBuscar();
    }
  }, [externalReference, navigate]);

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        {!erro ? (
          <>
            <h1 className="text-2xl font-bold text-indigo-700">Validando seu pagamento...</h1>
            <p className="mt-2 text-gray-600">Aguarde alguns instantes enquanto processamos sua transação.</p>
            <p className="mt-4 text-sm text-gray-500 animate-pulse">Verificando transação...</p>
            <p className="mt-2 text-sm text-gray-500">Redirecionando em {segundos} segundos...</p>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-red-600">Comprovante não localizado</h1>
            <p className="mt-2 text-gray-600">O pagamento foi processado, mas não conseguimos localizar o comprovante.</p>
            <p className="mt-4 text-gray-500">Você pode falar com a loja e informar o código:</p>
            <div className="mt-2 font-mono bg-gray-200 rounded px-4 py-2 text-lg">{externalReference}</div>
            <a
              className="mt-4 inline-block bg-green-600 text-white px-4 py-2 rounded shadow hover:bg-green-700 transition"
              href={`https://wa.me/5513982312653?text=Oi, acabei de pagar e meu código é ${externalReference}`}
              target="_blank" rel="noopener noreferrer"
            >
              Falar com a loja no WhatsApp
            </a>
          </>
        )}
      </div>
    </div>
  );
}
